
import Request from "../Helpers/Request";
const UserList = async () => {
    return await Request("admin/userlist", '', 'get');
}
const Projects = async () => {
    return await Request("admin/project/view-list", '', 'get');
}
const EditUser = async (data) => {
    return await Request("admin/userlist/edit/" + data, '', 'get');
}
const UpdateUser = async (data) => {
    return await Request("admin/userlist/update", data);
}
const getprofile = async (data) => {
    return await Request("profile", '', 'get');
}
const helpDeskList = async (data) => {
    return await Request("admin/userlist/help/desk/list", '', 'get');
}
const changeStatus = async (data) => {
    return await Request("admin/userlist/help/desk/status/", data);
};
const helpdesk = async (data) => {
    return await Request("admin/userlist/help/desk/status", data);
};
const loglist = async (data) => {
    return await Request("admin/log", '', 'get');
}
// details
const logDetailslist = async (data) => {
    return await Request("admin/log/details", '', 'get');
}
const admindashboard = async (data) => {
    return await Request(`admin/dashboard?userId=${data.user_id}&year=${data.year}&type=${data.type}`, '', 'get');

}
const adminclient = async (data) => {
    return await Request("admin/userlist/client", '', 'get');
}
const adminProducts = async (data) => {
  return await Request("admin/product", '', 'get');
}

const collection = async (data) => {
    return await Request("admin/product/collection", '', 'get');
}

const spare = async (data) => {
    return await Request("admin/product/spare", '', 'get');
}

const group = async (data) => {
   
    return await Request("admin/product/group", '', 'get');
}
const finish = async (data) => {
    return await Request("admin/product/finish", '', 'get');
}
const segment = async (data) => {
    return await Request("admin/product/segment", '', 'get');
}
const adminAddTheme = async (data) => {
    return await Request("admin/cover-images/add", data);
}
const UpdatePassword = async (data) => {
    return await Request("admin/change-password", data);
}
const DefaultPassword = async (data) => {
    return await Request("admin/default-password", data);
}
const adminUpdateProduct = async (data) => {
    return await Request("admin/product/update", data);
}
const GetChannels = async () => {
    return await Request("admin/userlist/channels", '', 'get');
}
const UserService = {
    UserList,
    Projects,
    EditUser,
    UpdateUser,
    getprofile,
    helpDeskList,
    changeStatus,
    loglist,
    logDetailslist,
    helpdesk,
    admindashboard,
    adminclient,
    adminProducts,
    adminAddTheme,
    UpdatePassword,
    collection,
    group,
    spare,
    finish,
    segment,
    adminUpdateProduct,
    DefaultPassword,
    GetChannels
}
export default UserService